import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import Sector from "../../../Models/Catalogue/Reporting/Sector";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class SectorCatalogueEntry extends CatalogueEntry<Sector> {

    constructor() {
        super("Sectors", Sector);
    }

    public get editRole() {
        return CatalogueRoles.Sectors.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.sectors;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveSectors;
    }
    
    public renderRow(item: Sector, meta: Model.TransformMetaType<Sector>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.sectorName} />
                <NeoGrid.Column bind={meta.sectorCode} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}